import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';

type IProps = {
  toggle: boolean;
  onClose: () => void;
  videoUrl: string;
  title: string;
};

const VideoModel: React.FC<IProps> = ({ toggle, onClose, videoUrl }) => {
  return (
    <Dialog
      open={toggle}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      scroll='body' // allows content to scroll if needed
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'center', // center vertically
        },
        '& .MuiPaper-root': {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          maxHeight: '90vh', // prevents overflow
        },
      }}
    >
      <IconButton
        aria-label='close'
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 1,
          color: 'white',
          backgroundColor: 'rgba(0,0,0,0.5)',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.7)',
          },
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ padding: 0 }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '80vh',
          }}
        >
          <video
            controls
            style={{
              width: '100%',
              height: '100%',
              maxHeight: '80vh',
              objectFit: 'contain',
            }}
          >
            <source src={videoUrl} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModel;
